import React from 'react';
import Button from './button';

// TODO: Update when props update
export default class ButtonDropdown extends Button {
  constructor(props) {
    super(props);

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onItemSelected = this.onItemSelected.bind(this);

    this.state = this.state || {};

    this.state.dropdownOpen = false;
  }

  onClick(event) {
    if (this.props.disabled === true) return;
    this.toggle();
    event.preventDefault();
  }

  onItemSelected(item) {
    if (this.props.disabled === true) return;
    if (this.props.onClick && !this.state.waiting) {
      this.waitForAction(this.props.onClick(item));
    }
  }

  show() {
    if (this.state.dropdownOpen) return;
    document.addEventListener("click", this.hide);
    this.setState({ dropdownOpen: true });
  }

  hide() {
    if (!this.state.dropdownOpen) return;
    document.removeEventListener("click", this.hide);
    this.setState({ dropdownOpen: false });
  }

  toggle() {
    if (this.state.dropdownOpen) {
      this.hide();
    } else {
      this.show();
    }
  }

  getClasses() {
    let classesList = super.getClasses();

    if (this.state.dropdownOpen) {
      classesList += ' open';
    }

    classesList += ' buttondropdown';

    return classesList;
  }

  getExtras() {
    let options = (this.props.options || []).map(
      (option, idx) => {
        return <DropdownItem onClick={this.onItemSelected} key={`button-dropdown-${idx}`} option={option} />;
      }
    );
    return <ul className="dropdown">{options}</ul>;
  }
}

class DropdownItem extends React.Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    if (this.props.onClick) {
      this.props.onClick(this.props.option);
      event.preventDefault();
    }
  }

  render() {
    let option = null;

    if (typeof this.props.option === 'string') {
      option = this.props.option;
    } else if (typeof this.props.option === 'object') {
      option = this.props.option.content;
    }

    return <li onClick={this.onClick} className="link">{option}</li>;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Button/dropdown.js
 **/